// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__28N6O","inner":"Footer_inner__2IAKv"};